import React from 'react';

import styled from '@mint-lib/styled';
import SliderM, { SliderProps as SliderPropsM } from '@mui/material/Slider';

import Box from '../Box/Box.jsx';
import Typography from '../Typography/Typography.jsx';

export interface SliderProps extends SliderPropsM {
  /**
   * The label text to be shown above the slider.
   * This will also serve as the accessible label if provided.
   */
  label?: string;
  /**
   * Content to show at the start of the slider.
   */
  slotStart?: any;
  /**
   * Content to show at the end of the slider.
   */
  slotEnd?: any;
  marks?: Array<{ label?: React.ReactNode; value: number }> | boolean;
}

export default function Slider({
  label,
  slotStart,
  slotEnd,
  marks,
  ...SliderProps
}: SliderProps) {
  return (
    <Wrapper {...(SliderProps.disabled ? { className: 'disabled' } : {})}>
      {label && (
        <SliderLabel aria-hidden="true" gutterBottom>
          {label}
        </SliderLabel>
      )}
      <SliderWrapper>
        {slotStart && <SliderSlot>{slotStart}</SliderSlot>}
        <SliderM
          size="small"
          marks={marks}
          valueLabelDisplay="auto"
          {...(label ? { 'aria-label': label } : {})}
          {...SliderProps}
        />
        {slotEnd && <SliderSlot>{slotEnd}</SliderSlot>}
      </SliderWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(Box)`
  * {
    font-size: 0.75rem !important;
  }

  &.disabled * {
    color: ${({ theme }) => theme.palette.text.disabled} !important;
    fill: ${({ theme }) => theme.palette.text.disabled} !important;
    user-select: none !important;
  }
`;

const SliderWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const SliderLabel = styled(Typography)`
  line-height: 100%;
  margin-bottom: 8px;
`;

const SliderSlot = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`;
